import React from "react";
import { PageLooperProvider } from "./contexts/PageLooper";

const App: React.FC = () => {
  return <PageLooperProvider />;
};

export default App;
